import type { PredictionAccuracy } from '@on3/api';
import clsx from 'clsx';
import { Text } from 'components/UI/Typography/Text';

import styles from './PredictionCenterPercentages.module.scss';

interface IPredictionAccuracyProps {
  percentageTitle?: string | null;
  percentageClassName?: string;
  accuracy?: PredictionAccuracy;
}

export const PredictionCenterPercentages = ({
  accuracy,
  percentageTitle,
  percentageClassName,
}: IPredictionAccuracyProps) => {
  const {
    total,
    correct,
    percentCorrect: percentageCorrectProp,
    averageDaysCorrect,
  } = accuracy || {};
  const percentageCorrect = percentageCorrectProp
    ? `${percentageCorrectProp?.toFixed(2)}%`
    : '-';

  return (
    <div className={clsx(styles.currentYearsContainer, percentageClassName)}>
      <Text className={styles.percent} component="span" variant="h1">
        {percentageCorrect}
      </Text>
      <Text className={styles.yearPick} variant="subtitle1">
        {percentageTitle}
      </Text>
      <Text
        className={styles.accuracyWrapper}
        component="span"
        variant="subtitle1"
      >
        {correct ?? '-'}
        <span className={styles.totalPicks}>{total ?? '-'}</span>
      </Text>
      <div className={styles.avgDaysWrapper}>
        <Text className={styles.avgDays} variant="subtitle1">
          <span aria-label="Average">Avg.</span> Days Correct:
        </Text>
        <Text component="span" variant="subtitle1">
          {averageDaysCorrect?.toFixed(2) ?? '-'}
        </Text>
      </div>
    </div>
  );
};
